import I18n from "./wrapper";

export default I18n;
